import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useNavigationBlocker(when: boolean, onBlock: () => void) {
    const location = useLocation();

    useEffect(() => {
        if (!when) return;

        // popstate 이벤트 (뒤로가기, 앞으로가기)
        const handlePopState = (e: PopStateEvent) => {
            e.preventDefault();
            window.history.pushState(null, '', location.pathname);
            onBlock();
        };

        // 현재 위치를 history에 push (뒤로가기 방지용)
        window.history.pushState(null, '', location.pathname);
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [when, location.pathname, onBlock]);
}
